import { Mail } from 'lucide-react';
import { useParams } from 'react-router-dom';
import Spinner from '../components/Spinner';
import NewsletterFormPreview from '../components/lead-capture/NewsletterFormPreview';
import { usePublicNewsletterSettings } from '../hooks/useLeadSettings';

const DEFAULT_COLORS = {
  primaryColor: '#172554',
  secondaryColor: '#e2e8f0',
  buttonColor: '#7f1d1d',
  accentColor: '#be123c',
  companyName: 'Strivre Services',
  logoUrl: '',
};

// Public embeddable Newsletter Subscription page, e.g. https://app.strivre.com/newsletter/:slug
// Modeled after PublicJobBoardPage.tsx's public branding lookup / rendering pattern.
export default function PublicNewsletterPage() {
  const { slug = '' } = useParams();
  const settings = usePublicNewsletterSettings(slug);
  const colors = settings.data ?? DEFAULT_COLORS;

  if (settings.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className="w-full min-h-screen bg-slate-50 py-10"
      style={
        {
          '--newsletter-primary': colors.primaryColor,
          '--newsletter-secondary': colors.secondaryColor,
          '--newsletter-button': colors.buttonColor,
          '--newsletter-accent': colors.accentColor,
        } as React.CSSProperties
      }
    >
      <div className="mx-auto flex max-w-xl flex-col items-center gap-3 px-4 text-center">
        {colors.logoUrl ? (
            <img
                src={colors.logoUrl}
                alt={colors.companyName ?? 'Company Logo'}
                className="max-h-20 w-auto object-contain"
            />
        ) : (
            <div style={{ backgroundColor: 'var(--newsletter-primary)' }} className="flex h-14 w-14 items-center justify-center rounded-2xl text-white">
                <Mail size={26} />
            </div>
        )}

        <h1
            className="text-3xl font-bold"
            style={{ color: 'var(--newsletter-primary)' }}
        >
            {colors.companyName ?? 'Stay Updated'}
        </h1>

        <p className="max-w-md text-sm text-slate-500">
            Subscribe to receive updates, announcements, promotions, and news from{' '}
            <span
            className="font-semibold"
            style={{ color: 'var(--newsletter-accent)' }}
            >
            {colors.companyName ?? 'our team'}
            </span>
            .
        </p>

        </div>

      <div className="mx-auto mt-8 max-w-xl px-4">
        <NewsletterFormPreview colors={colors} interactive />
      </div>
    </div>
  );
}
